import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinModelCenter = {
  async modelSelect() {
    // let [err, res] = [null, null]
    const [err, res] = await To(wizStandardInstance.get('/api/Document/GetDicItemAsync'))
    return Callback.globalCB(err, res)
  },
  async apiModelCenter(
    arg = {
      method: '',
      params: {},
      formData: {},
      ids: [],
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'add':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/Document/AddModelasync', arg.formData)
        )
        break
      case 'addMultiple':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/Document/addmultiplemodelasync', arg.formData)
        )
        break
      case 'editMultiple':
        ;[err, res] = await To(wizStandardInstance.patch('/api/Document/handover', arg.params))
        break
      case 'deleteModelFile':
        ;[err, res] = await To(wizStandardInstance.post('/api/DocumentFile/DeleteAsync', arg.ids))
        break
      case 'edit':
        ;[err, res] = await To(wizStandardInstance.post('/api/Document/UpdateAsync', arg.params))
        break
      case 'delete':
        const deleteObj = {
          id: ' ',
        }
        if (arg.params && arg.params.id) {
          _.assign(deleteObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.post(encodeUrl(`/api/Document/DeleteModelAsync/${deleteObj.id}`))
        )
        break
      case 'getAttribute':
        const getAttributeObj = {
          siteId: ' ',
          name: ' ',
          code: ' ',
        }
        if (arg.params) {
          _.assign(getAttributeObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/Document/GetAttributeAsync/${getAttributeObj.siteId}/${getAttributeObj.name}/${getAttributeObj.code}`
            )
          )
        )
        break
      case 'getAttributeNew':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/Document/GetAttributeAsync/', {
            where: arg.params,
          })
        )
        break
      case 'detail':
        const detailObj = {
          id: ' ',
        }
        if (arg.params && arg.params.id) {
          _.assign(detailObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(encodeUrl(`/api/Document/GetModelDetailAsync/${detailObj.id}`))
        )
        break
      case 'multipleDetail':
        const multipleDetailObj = {
          id: ' ',
        }
        if (arg.params && arg.params.id) {
          _.assign(multipleDetailObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/Document/handover/multi_model/${multipleDetailObj.id}`)
          )
        )
        break
      // new modelCenter
      case 'queryModel':
        ;[err, res] = await To(wizStandardInstance.post('/api/Document/query_model', arg.params))
        break
      case 'newDetail':
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/Document/query_detail/${arg.params.id}`)
        )
        break
      case 'modelTree':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/Document/query_model_tree', arg.params)
        )
        break
      case 'addModel':
        ;[err, res] = await To(wizStandardInstance.post('/api/Document/save_model', arg.formData))
        break
      case 'editModel':
        ;[err, res] = await To(wizStandardInstance.patch('/api/Document/save_model', arg.formData))
        break
      case 'deleteModel':
        ;[err, res] = await To(
          wizStandardInstance.delete('/api/Document/delete_model', {
            data: arg.ids,
          })
        )
        break
      case 'compareModel':
        ;[err, res] = await To(wizStandardInstance.post('/api/Document/model_compare', arg.params))
        break
      case 'saveMarkList':
        ;[err, res] = await To(
          wizStandardInstance.post(
            `/file/set_file_marking/${arg.params.fileId}/${arg.params.type}`,
            arg.params.markingList
          )
        )
        break
      case 'getMarkList':
        ;[err, res] = await To(
          wizStandardInstance.get(`/file/get_file_marking/${arg.params.fileId}/${arg.params.type}`)
        )
        break
      default:
        const listObj = {
          siteId: ' ',
          keywords: ' ',
          stageId: ' ',
          startTime: ' ',
          endTime: ' ',
        }
        if (arg.params) {
          _.assign(listObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/Document/GetModelListAsync/${listObj.siteId}/${listObj.keywords}/${listObj.stageId}/${listObj.startTime}/${listObj.endTime}`
            )
          )
        )
    }
    return Callback.globalCB(err, res)
  },
}

export default {
  methods: ApiMixinModelCenter,
}
